import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { isError } from 'flux-standard-action/lib/index';

const successMutationGenerator = ({ ccMenuSelectedIndexes }) => ({
  ccMenuSelectedIndexes: { $set: ccMenuSelectedIndexes },
  error: { $set: null },
});

const errorMutationGenerator = (error) => ({
  error: { $set: error },
});

const stateMutationGenerator = (action) =>
  isError(action) ? errorMutationGenerator : successMutationGenerator;

export const playerCCMenuChangeIndexReducer = (currentState, action) =>
  updateState(currentState, stateMutationGenerator(action)(payloadExtractor(action)));
